import { push, replace } from 'connected-react-router';
import { actionCreators as Notification } from './Notification';
import restHttp from '../../utils/restHttp';

const requestListType = 'loyality/publication/list/request';
const receiveListType = 'loyality/publication/list/receive';
const requestGetType = 'loyality/publication/get/request';
const receiveGetType = 'loyality/publication/get/receive';
const requestPostType = 'loyality/publication/post/request';
const receivePostType = 'loyality/publication/post/receive';
const requestPutType = 'loyality/publication/put/request';
const receivePutType = 'loyality/publication/put/receive';
const requestDeleteType = 'loyality/publication/delete/request';
const receiveDeleteType = 'loyality/publication/delete/receive';
const switchDisplayStyle = 'loyality/publication/display';

const initialState = {
  list: [],
  paging: { sortBy: 'createdOn', sortDescending: true },
  preferTable: false,
};

export const actionCreators = {
  requestList: (pageIndex, pageSize, sortBy, sortDescending) => (dispatch) => {
    dispatch({ type: requestListType });

    restHttp
      .get('publication', restHttp.pageOptions(pageIndex, pageSize, sortBy, sortDescending))
      .then((response) => {
        dispatch({
          type: receiveListType,
          list: response.data,
          paging: restHttp.pagingHeader(response),
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestGet: id => (dispatch) => {
    dispatch({ type: requestGetType });

    restHttp
      .get(`publication/${id}`)
      .then((response) => {
        dispatch({
          type: receiveGetType,
          current: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPost: entity => (dispatch) => {
    dispatch({ type: requestPostType });

    restHttp
      .post('publication', entity)
      .then((response) => {
        dispatch({
          type: receivePostType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Publikācija izveidota!'));
        dispatch(replace('/publication'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPut: (id, entity) => (dispatch) => {
    dispatch({ type: requestPutType });

    restHttp
      .put(`publication/${id}`, entity)
      .then((response) => {
        dispatch({
          type: receivePutType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Publikācija atjaunota!'));
        // dispatch(push('/publication'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestDelete: id => (dispatch) => {
    dispatch({ type: requestDeleteType });

    restHttp
      .delete(`publication/${id}`)
      .then(() => {
        dispatch({
          type: receiveDeleteType,
        });
        dispatch(Notification.addSuccess('Publikācija izdzēsta!'));
        dispatch(push('/publication'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  switchDisplayStyle: () => (dispatch) => {
    dispatch({ type: switchDisplayStyle });
  },
};

export const reducer = (state, action) => {
  const newState = state || initialState;

  if (action.type === receiveListType) {
    return {
      ...newState,
      list: action.list,
      paging: action.paging,
    };
  }

  if (action.type === receiveGetType || action.type === receivePostType || action.type === receivePutType) {
    return {
      ...newState,
      current: action.current,
    };
  }

  if (action.type === switchDisplayStyle) {
    return {
      ...newState,
      preferTable: !state.preferTable,
    };
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/store/modules/Publication.js